(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_background-slider"] && !Shopify.designMode) return;
  try {
    ///check if yc-background-slides is already defined
    if (!customElements.get('yc-background-slides')) {

  
    class YCBackgroundSlides extends HTMLElement {
      constructor( interval = 5000) {
        super();

        this.slides = this.querySelectorAll('.yc-background-slider_slide');
        this.currentIndex = 0;
        this.interval = interval;
        this.timer = null;

        if (this.slides.length === 0) return;

        this.showSlide(this.currentIndex);
        this.start();


      }

      showSlide(index) {
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === index);
        });

        this.classList.remove('yc-background-slider--in-active');
      }

      nextSlide() {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.showSlide(this.currentIndex);
      }

      start() {
        this.timer = setInterval(() => this.nextSlide(), this.interval);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
      }
    }

   
    
    customElements.define('yc-background-slides', YCBackgroundSlides);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_background-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('background-video')) {
class BackgroundVideo extends HTMLElement {
  constructor() {
    super();
    this.landscapeVideo = this.querySelector(`.background-video__landscape`);
    this.portraitVideo = this.querySelector(`.background-video__portrait`);
    this.videoObserver = null;

    this.init();
  }

  init() {
    this.removeMediaAttributes();
  }

  removeMediaAttributes() {
    // remove media attribute from source elements to prevent browser from auto-selecting the wrong video
    if (this.landscapeVideo) {
      const landscapeSources = this.landscapeVideo.getElementsByTagName('source');
      for (let i = 0; i < landscapeSources.length; i++) {
        landscapeSources[i].removeAttribute('media');
      }
    }
    if (this.portraitVideo) {
      const portraitSources = this.portraitVideo.getElementsByTagName('source');
      for (let i = 0; i < portraitSources.length; i++) {
        portraitSources[i].removeAttribute('media');
      }
    }
  }



 
}

  customElements.define('background-video', BackgroundVideo);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_consultation-form"] && !Shopify.designMode) return;
  try {
    class YCConsultationForm extends HTMLElement {
    constructor() {
        super();
        this.selectElement = this.querySelector('.yc-consultation-form__select');
        this.button = this.querySelector('.yc-consultation-form__submit-button');

        console.log('Button element on init:', this.button);


        this.handleSelectChange = this.handleSelectChange.bind(this);
        // select the first option by default
        if (this.selectElement && this.selectElement.options.length > 0) {
            this.selectElement.selectedIndex = 0;
        }

        this.handleSelectChange();
       
    }

    connectedCallback() {
        if (this.selectElement) {
            this.selectElement.addEventListener('change', this.handleSelectChange);
        }
    }

    disconnectedCallback() {
        if (this.selectElement) {
            this.selectElement.removeEventListener('change', this.handleSelectChange);
        }
    }

    handleSelectChange(event) {
        // get the selected option's data-option-value attribute
        const selectedOptionElement = this.selectElement.selectedOptions[0];
        const selectedOptionValue = selectedOptionElement.querySelector('span').dataset.optionValue;
        console.log('Selected option element:', selectedOptionElement);
        console.log('Selected option:', selectedOptionElement.querySelector('span').dataset.optionValue);
        this.button.href = selectedOptionValue;
    }
}

customElements.define('yc-consultation-form', YCConsultationForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-mega-menu"] && !Shopify.designMode) return;
  try {
    // Initialize the mega menu functionality here if needed



    //console.log('Mega Menu initialized');

    const menuSections = document.querySelectorAll('.yc-mega-menu-v2__top-level');
    const activeClass = 'yc-mega-menu-v2__top-level--active';

    function activeMenuSection(event) {
        const target = event.currentTarget;
        menuSections.forEach(section => {
            if (section !== target) {
                section.classList.remove(activeClass);
            }
        });
        target.classList.toggle(activeClass);

        // add aria-expanded attribute to the button
        const button = target.querySelector('.yc-mega-menu-v2__top-level-label');
        if (button) {
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !isExpanded);
        }

        // add a class to the header
        const header = document.querySelector('.yc-header');
        if (header) {
            header.classList.add('menu-open');
        }
      }


    menuSections.forEach(section => {
        section.addEventListener('click', activeMenuSection);
    });

    // on click outside the menu, close all open sections
    document.addEventListener('click', function(event) {
        //console.log('Clicked outside the menu',event.target.closest('.yc-mega-menu-v2__top-level'));
        if (!event.target.closest('.yc-mega-menu-v2__top-level')) {
            menuSections.forEach(section => {
                section.classList.remove(activeClass);
            });

             // remove a class to the header
        const header = document.querySelector('.yc-header');
        if (header) {
            header.classList.remove('menu-open');
        }

    }
       
    });


    // add a varibale to yc-mega-menu-v2-height-style to set the height of the mega menu based on the height of the header
    function updateMegaMenuHeight() {
        const header = document.querySelector('.yc-header');
        const megaMenuStyle = document.getElementById('yc-mega-menu-v2-height-style');
        if (header && megaMenuStyle) {
            const headerHeight = header.offsetHeight;
            megaMenuStyle.innerHTML = `
                :root {
                    --yc-header-height: ${headerHeight}px;
                }
            `;
        }
    }

    updateMegaMenuHeight();
    window.addEventListener('resize', updateMegaMenuHeight);
    setInterval(updateMegaMenuHeight, 1000); // in case of late loading fonts or images
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_header-portrait-menu"] && !Shopify.designMode) return;
  try {
    // sub menu functionality
  const subMenus = document.querySelectorAll('.yc-portrait-menu__sub-menu');

  subMenus.forEach(subMenu => {
      const title = subMenu.querySelector('.yc-portrait-menu__sub-menu-title');
      if (title) {
          title.addEventListener('click', function() {
            console.log('Sub menu clicked', subMenu?.querySelector('.yc-portrait-menu__sub-menu-content'));
              subMenu?.querySelector('.yc-portrait-menu__sub-menu-content').classList.toggle('yc-portrait-menu__sub-menu-content--active');
          });
      }

      const backButton = subMenu.querySelector('.yc-portrait-menu__sub-menu-back');

      if (backButton) {
          backButton.addEventListener('click', function() {
            console.log('Back button clicked');
              subMenu?.querySelector('.yc-portrait-menu__sub-menu-content').classList.remove('yc-portrait-menu__sub-menu-content--active');
          });
      }

      // find the closet .yc-portrait-menu__sub-menu-back upwards in the DOM
      const backButtonUpwards = subMenu?.parentElement?.parentElement?.querySelector('.yc-portrait-menu__sub-menu-title');
      if (backButtonUpwards) {
        //console.log('Back button upwards found', backButtonUpwards);
      }
    });


  // open close 

  const hamburger = document.querySelector('.yc-portrait-menu__hamburger');
  const portraitMenu = document.querySelector('.yc-portrait-menu');
  const closeButton = document.querySelector('.yc-portrait-menu__close');
  const veil = document.querySelector('.yc-portrait-menu__veil');


  hamburger.addEventListener('click', function() {
    console.log('Hamburger clicked');
    portraitMenu.classList.add('open');
    document.querySelector('body').style.overflow = 'hidden'; // Prevent body scroll when menu is open
  });

  function closeMenu() {
    console.log('Closing portrait menu');
    portraitMenu.classList.remove('open');
    document.querySelector('body').style.overflow = 'auto'; // Restore body scroll when menu is closed
  }

  closeButton.addEventListener('click', closeMenu);
  veil.addEventListener('click', closeMenu);



  // Search functionality
  const searchLink = document.querySelector('.yc-portrait-menu__search-link');
  if (searchLink) {
    searchLink.addEventListener('click', function(event) {
      event.preventDefault();
      const searchIcon = document.querySelector('yc-search .search-icon');
      if (searchIcon) {
        console.log('Search icon found, opening search', searchIcon);
        searchIcon.click();
      }
    });
  }

  //console.log('Portrait Menu initialized');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-paint-calulator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yc-product-paint-calculator')) {
        class ProductPaintCalculator extends HTMLElement {

            constructor(){
            super();
            // form 
            this.form = this.querySelector('form');
            this.widthInput = this.form.querySelector('input[name="width"]');
            this.heightInput = this.form.querySelector('input[name="height"]');
            this.unitSelect = this.form.querySelector('select[name="unit"]');
            this.resultDiv = this.querySelector('.yc-product__paint-calculator__result');

            this.widthInput.addEventListener('change', this.onChange.bind(this));
            this.heightInput.addEventListener('change', this.onChange.bind(this));
            this.unitSelect.addEventListener('change', this.onChange.bind(this));

            // add event for a new number is input
            this.widthInput.addEventListener('input', this.onChange.bind(this));
            this.heightInput.addEventListener('input', this.onChange.bind(this));

            // closest variant selector.
            this.closestVariantSelector =  document.querySelector('select.yc-product__variant-select');
            //console.log('Closest variant selector:', this.closestVariantSelector);
            //console.log("All variant selectors:", document.querySelectorAll('select.yc-product__variant-select'));
            //console.log('Paint Calculator Initialized');
        }

        onChange(){
            const width = parseFloat(this.widthInput.value);
            const height = parseFloat(this.heightInput.value);

            //console.log("Calculating paint needed...",width,'x',height);

            if(isNaN(width) || isNaN(height) ){
                console.log('Invalid input, clearing result');
                this.resultDiv.classList.remove('visible');
                this.resultDiv.innerHTML = '';
                return;
            }

            if (!isNaN(width) && !isNaN(height)) {
                let area = width * height;

                let modifier = 1;
                if(this.unitSelect.value === "feet"){
                    modifier = 10.764; // 1 square meter = 10.764 square feet
                }

                 area = area / modifier

                 console.log('Area in square meters:', area);


                if(window.mattCovarage){
                    console.log('Using global coverage settings');
                    paintCalculatorSettings.mattCovarage = window.mattCovarage;
                }

                let coverage = paintCalculatorSettings.mattCovarage;


                if(this?.closestVariantSelector?.value === 'eggshell'){
                    coverage = paintCalculatorSettings.eggshellCovarage;
                }

                const litres = (area / coverage) ; // 1 litre covers 10 square meters

            
                if( this.resultDiv ){
           
                    this.resultDiv.classList.add('visible');
                    this.resultDiv.innerHTML = `Result: You'll need ${litres.toFixed(1)} litres of paint for one coat, or ${ (litres * 2).toFixed(1) } litres for 2 coats. We recommend two coats for best results.`;
                }else{
                    console.warn('No result div found');
                }
            }
        }

    }
    // Initialize the calculator
    customElements.define("yc-product-paint-calculator",ProductPaintCalculator);
  
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-variant-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const finishSelect = document.querySelector('.yc-product-variant-selector__finish');
  const finishSelectElement = finishSelect.querySelector('select');

  const variantWrapers = document.querySelectorAll('.yc-product-variant-selector-wrapper');

  let currentProduct = null;

  let currentFinish = null;

  // get current finish by checking which option is selected
  function getCurrentFinish() {
      currentFinish = finishSelectElement.value;
  }
  getCurrentFinish();


  function selectFinish(finish) {


      // get previous finish
      const previousFinish = currentFinish;
      let selectedSizeLabel = null;
      // get previous size selected
        variantWrapers.forEach(wrapper => {
             if (wrapper.dataset.finish === previousFinish) {
                const sizeSelect = wrapper.querySelector('select');
                if (sizeSelect) {
                    // get selected size label
                    selectedSizeLabel = sizeSelect.options[sizeSelect.selectedIndex].text;
                }
            }
        });

      currentFinish = finish;

      console.log('Switching to finish:', finish, ' from previous finish:', previousFinish, ' with size:', selectedSizeLabel);

      variantWrapers.forEach(wrapper => {
          if (wrapper.dataset.finish === finish) {
              wrapper.style.display = "block";
              // dispatch change event to update the product form

              // set the size if they match
              const sizeSelect = wrapper.querySelector('select');
              if (sizeSelect) {
                  const matchingSizeOption = Array.from(sizeSelect.options).find((option) =>  option.text === selectedSizeLabel )
                  if (matchingSizeOption) {
                      sizeSelect.value = matchingSizeOption.value;
                  }    
              }

              wrapper.querySelector('select').dispatchEvent(new Event("change"));
          } else {
              wrapper.style.display = "none";
          }
      });


      // look for a product type label 
      const productTypeLabel = document.querySelector('.yc-product__type');
      if (productTypeLabel) {
          let typeText = '';
          if (finish === 'eggshell') {
              typeText = 'Eggshell';
          } else if (finish === 'matt') {
              typeText = 'Matt emulsion';
          } else if (finish === 'masonry') {
              typeText = 'Masonry';  
          }
          productTypeLabel.textContent = typeText;
        }
  }


  finishSelectElement.addEventListener('change', function(event) {
      const selectedFinish = event.target.value;
      console.log("Selected finish:", selectedFinish);
      selectFinish(selectedFinish);
  });
  /*
  finishSelect.addEventListener('click', function(event) {
      const selectedFinish = finishSelectElement.value;
      console.log("Selected finish:", selectedFinish);
      //selectFinish(selectedFinish);
  });*/
});
  } catch(e) { console.error(e); }
})();

})();
